import { ISmartGroup } from "../../engine/DataModels/ISmartPattern";
import biblio_200_220_3_2 from "../../assets/patterns/biblio-200-220-3.2.png";
import biblio_221_250_3_2 from "../../assets/patterns/biblio-221-250-3.2.png";

const GKEY = "3.2";
export const BiblioGroup3_2: ISmartGroup = {
    key: GKEY,
    modulesByInterval: [
        {
            groupKey: GKEY,
            itvalIdx: 0,
            icon: biblio_200_220_3_2,
            zones: [
            { Ac:3, SWD: [0,0] },
            { Ac:1 }, 
            { Ac:1 }, 
            { Ac:2 }, 
            { Ac:1 }, 
            { Ac:1 }
        ]},
        {
            groupKey: GKEY,
            itvalIdx: 1,
            icon: biblio_221_250_3_2,
            zones: [
            { Ac:3, SWD: [1,1,1] },
            { Ac:2 }, 
            { Ac:1 }, 
            { Ac:2 }, 
            { Ac:1 },
            { Ac:1 }
        ]}
    ]
}